/** Must match [frontend/src/styles/themes.css](frontend/src/styles/themes.css) data-theme values. */
export const THEME_IDS = [
  'default',
  'ocean',
  'forest',
  'sunset',
  'mono',
  'lavender',
  'rose',
  'midnight',
  'sand',
  'aurora',
];

export const THEME_MODES = ['light', 'dark'];

export const STORAGE_THEME = 'tk_theme';
export const STORAGE_MODE = 'tk_theme_mode';

export const THEME_LABELS = {
  default: 'Terra',
  ocean: 'Ocean',
  forest: 'Forest',
  sunset: 'Sunset',
  mono: 'Mono',
  lavender: 'Lavender',
  rose: 'Rose',
  midnight: 'Midnight',
  sand: 'Sand',
  aurora: 'Aurora',
};

/** Preview swatches for settings grid (approximate CSS primary HSL feel) */
export const THEME_SWATCHES = {
  default: 'linear-gradient(135deg, hsl(187 94% 43%), hsl(240 6% 35%))',
  ocean: 'linear-gradient(135deg, hsl(199 89% 48%), hsl(222 40% 25%))',
  forest: 'linear-gradient(135deg, hsl(152 69% 48%), hsl(144 22% 18%))',
  sunset: 'linear-gradient(135deg, hsl(25 95% 53%), hsl(350 75% 45%))',
  mono: 'linear-gradient(135deg, hsl(240 5% 72%), hsl(240 6% 20%))',
  lavender: 'linear-gradient(135deg, hsl(263 70% 58%), hsl(270 25% 18%))',
  rose: 'linear-gradient(135deg, hsl(330 75% 60%), hsl(340 22% 14%))',
  midnight: 'linear-gradient(135deg, hsl(234 89% 68%), hsl(224 40% 12%))',
  sand: 'linear-gradient(135deg, hsl(24 75% 55%), hsl(30 15% 20%))',
  aurora: 'linear-gradient(135deg, hsl(172 66% 48%), hsl(270 55% 45%))',
};

export function isValidThemeId(id) {
  return typeof id === 'string' && THEME_IDS.includes(id);
}

export function isValidMode(mode) {
  return mode === 'light' || mode === 'dark';
}

/**
 * Apply theme to document.documentElement and persist to localStorage.
 */
export function applyThemeToDocument(themeId, mode) {
  const t = isValidThemeId(themeId) ? themeId : 'default';
  const m = isValidMode(mode) ? mode : 'dark';
  const root = document.documentElement;
  root.setAttribute('data-theme', t);
  if (m === 'dark') {
    root.classList.add('dark');
  } else {
    root.classList.remove('dark');
  }
  try {
    localStorage.setItem(STORAGE_THEME, t);
    localStorage.setItem(STORAGE_MODE, m);
  } catch {
    /* ignore */
  }
  return { themeId: t, mode: m };
}

/**
 * Read saved preference from localStorage (browser only).
 */
export function readStoredTheme() {
  try {
    const themeId = localStorage.getItem(STORAGE_THEME);
    const mode = localStorage.getItem(STORAGE_MODE);
    return {
      themeId: isValidThemeId(themeId) ? themeId : 'default',
      mode: isValidMode(mode) ? mode : 'dark',
    };
  } catch {
    return { themeId: 'default', mode: 'dark' };
  }
}
